import * as React from 'react';

/**
 * Header context contains a copy of `headerProps` so that a MenuModal can
 * render an identical `Header` inside it
 */
var HeaderContext = /*#__PURE__*/
React.createContext({
  headerProps: undefined,
  colorProps: undefined
});

export { HeaderContext };
